import * as Yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";
import { COMPANY_WEBSITE_REQUIRED, COMPANY_WEBSITE_VALID, EMAIL_REQUIRED, INVALID_EMAIL, INVALID_PHONE, PHONE_REQUIRED } from "../constants/messages";

/**
 * Phone validator using Yup.
 * 
 * @constant
 * @name phoneValidator
 * @type {Yup.StringSchema<string>}
 */
export const phoneValidator = Yup.string().required(PHONE_REQUIRED).transform((value: string) => value.trim()).test('customValidation1', INVALID_PHONE, (value) => isValidPhoneNumber(value))

/**
 * Email validator using Yup.
 * 
 * @constant
 * @name emailValidator
 * @type {Yup.StringSchema<string>}
 */
// export const emailValidator = Yup.string().email(INVALID_EMAIL).matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, INVALID_EMAIL).transform((value: string) => value.trim()).required(EMAIL_REQUIRED)
export const emailValidator = Yup.string()
    .trim()
    .email(INVALID_EMAIL)
    // .matches( /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/, INVALID_EMAIL)
    .matches( /^(?!\.)(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])(?<!\.)$/, INVALID_EMAIL)
    .required(EMAIL_REQUIRED);

/**
 * Company Website using Yup.
 * 
 * @constant
 * @name phoneValidator
 * @type {Yup.StringSchema<string>}
*/
// export const URLREGEX = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
// export const URLREGEX = /^(https?:\/\/)(?!localhost|127\.0\.0\.1)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$|^(https?:\/\/)(?!localhost|127\.0\.0\.1)(\d{1,3}\.){3}\d{1,3}(:\d+)(\/.*)?$/;
export const URLREGEX = /^(https?:\/\/)(?!localhost|127\.0\.0\.1)([a-zA-Z0-9.-]+|\d{1,3}(\.\d{1,3}){3})(:\d{1,5})?(\/.*)?$/;

export const URLValidator = (requiredMessage: any, invalidURLMessage: any) => {
    return Yup.string().trim().required(requiredMessage)
    .url(invalidURLMessage)
    .matches(URLREGEX, invalidURLMessage)
}
